import { Head, Link } from '@inertiajs/react'
import SuperAdminLayout from '../_SuperAdminLayout'
import { StatusPill } from '../Dashboard'

interface Tenant {
  id: number
  name: string
  slug: string
  status: string
  user_count: number
  team_count: number
  last_backup_display: string
  created_at_display: string
}

interface Props { tenants: Tenant[] }

export default function TenantsIndex({ tenants }: Props) {
  return (
    <SuperAdminLayout>
      <Head title="SuperAdmin · Tenants" />
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-text-primary">Tenants ({tenants.length})</h1>
        <Link href="/super_admin/tenants/new" className="px-4 py-2 bg-[#ED1C24] text-white rounded-lg text-sm font-semibold hover:bg-[#C7161E]">
          + Create tenant
        </Link>
      </div>

      <div className="bg-white border border-stone/20 rounded-lg overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#F5F5F5] text-text-secondary">
            <tr>
              <th className="text-left py-3 px-4 font-semibold">Name</th>
              <th className="text-left py-3 px-4 font-semibold">Slug</th>
              <th className="text-left py-3 px-4 font-semibold">Status</th>
              <th className="text-left py-3 px-4 font-semibold">Users</th>
              <th className="text-left py-3 px-4 font-semibold">Teams</th>
              <th className="text-left py-3 px-4 font-semibold">Last backup</th>
              <th className="text-left py-3 px-4 font-semibold">Created</th>
            </tr>
          </thead>
          <tbody>
            {tenants.length === 0 && (
              <tr><td colSpan={7} className="py-12 text-center text-text-muted">No tenants yet.</td></tr>
            )}
            {tenants.map(t => (
              <tr key={t.id} className="border-t border-stone/10 hover:bg-[#F5F5F5]/50">
                <td className="py-3 px-4">
                  <Link href={`/super_admin/tenants/${t.id}`} className="font-semibold text-text-primary hover:underline">{t.name}</Link>
                </td>
                <td className="py-3 px-4 text-text-muted font-mono text-xs">{t.slug}</td>
                <td className="py-3 px-4"><StatusPill status={t.status} /></td>
                <td className="py-3 px-4 text-text-secondary">{t.user_count}</td>
                <td className="py-3 px-4 text-text-secondary">{t.team_count}</td>
                <td className="py-3 px-4 text-text-secondary">{t.last_backup_display}</td>
                <td className="py-3 px-4 text-text-secondary">{t.created_at_display}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </SuperAdminLayout>
  )
}
